export const approve = async function(vm) {
  console.log("approve order vm: ", vm.confirmation);
  // let vm = vm;
  vm.dirty = true;
  let postURL = `${SERVER_API[ENV]}mflow/OrderChangeStatus?order_id=${vm.orderId}&status_id=3`;
  return fetch(postURL, {
    method: "POST",
    headers: { t: vm.userToken, u: vm.userID }
  })
    .then(res => res.json())
    .then(response => {
      console.log("status changed >> ", response);
      if (response === "ok") {
        vm.$toasted.show("Order has been approved", {
          position: "top-center",
          // iconPack: "fontawesome",
          type: "success",
          theme: "bubble",
          icon: {
            name: "fal fa-check-circle mr-xs"
          }
        });
        // vm.initOrdersList();
        vm.$router.push("/");
      } else {
        vm.$toasted.show("Something went wrong.. please try again", {
          position: "bottom-center",
          // iconPack: "fontawesome",
          type: "warning",
          theme: "bubble",
          icon: {
            name: "fal fa-exclamation-circle mr-xs"
          }
        });
      }
      // commit("SET_ORDERS_LIST", response);
    })
    .catch(err => err);
};
